import React, { Component } from 'react';
import { Button, CardBody, Input, Form, FormGroup, Label, ButtonDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { getDate } from '../actions';
import { connect } from 'react-redux';
import Datetime from 'react-datetime';
import { trimCharsStart } from 'lodash/fp';

const mapDispatchToProps = dispatch => {
  return {
    getDate: (sdate, edate) => dispatch(getDate(sdate, edate)),
  };
};


const today = new Date();

const year = today.getFullYear();
const yyyy = year.toString();
const yminusone = (year-1).toString();

const month = (today.getMonth()+1<10 ? '0' : '')+(today.getMonth()+1);
const mm = month.toString();

const day = (today.getDate()<10 ? '0' : '')+today.getDate();
const dd = day.toString();

const currentHHMM = ' ' + today.getHours() +':' + today.getMinutes();
const zeroHHMM = ' 00:00'
const fullHHMM = ' 23:59'

const dateFormat = (date, zeroTime) => {
  if (zeroTime) {
    return date.substring(0,4) + '/' + date.substring(5,7) + '/' + date.substring(8,10) + zeroHHMM;
  }
  else {
    return date.substring(0,4) + '/' + date.substring(5,7) + '/' + date.substring(8,10)
  }
}

const currentDate = yyyy + '/' + mm + '/' + dd + fullHHMM;
const currentDateTime = yyyy + '/' + mm + '/' + dd + currentHHMM;
const lastOne =  dateFormat((new Date(new Date().getTime()-(1*24*60*60*1000))).toISOString().slice(0, 10), false);
const lastSeven = dateFormat((new Date(new Date().getTime()-(7*24*60*60*1000))).toISOString().slice(0, 10), true);
const lastThrity = dateFormat((new Date(new Date().getTime()-(30*24*60*60*1000))).toISOString().slice(0, 10), true);
const lastSixty = dateFormat((new Date(new Date().getTime()-(60*24*60*60*1000))).toISOString().slice(0, 10), true);
const lastNinety = dateFormat((new Date(new Date().getTime()-(90*24*60*60*1000))).toISOString().slice(0, 10), true);
const lastYear = yminusone + '/' + mm + '/' + dd + zeroHHMM;

var moment = require('moment');
moment.locale('zh-tw', {
    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
    monthsShort : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
    monthsParseExact : true,
    weekdays : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
    weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
    weekdaysParseExact : true,
});

require('moment/locale/zh-tw');

class TimeSelectComponent extends Component {
	constructor(props) {
		super(props);
		this.state = {
			timeDropdownOpen: false,
			sdate: lastSeven,
			edate: currentDate,
      sdateInvalid: false,
      edateInvalid: false,
			status: '過去7天',
      datePickOpen: false,
      eOpen:false,
      sOpen:false,
		};
		this.timeSelectToggle = this.timeSelectToggle.bind(this);
		this.dateChange = this.dateChange.bind(this);
		this.sendDate = this.sendDate.bind(this);
		this.confirm = this.confirm.bind(this);
		this.cancle = this.cancle.bind(this);
    this.oneDay = this.oneDay.bind(this);
    this.sevenDays = this.sevenDays.bind(this);
		this.thirtyDays = this.thirtyDays.bind(this);
		this.sixtyDays = this.sixtyDays.bind(this);
		this.ninetyDays = this.ninetyDays.bind(this);
    this.oneYear = this.oneYear.bind(this);
    this.onFocus = this.onFocus.bind(this);
    this.onBlur = this.onBlur.bind(this);
	}

  componentDidMount(){
    // Moved from componentWillMount
    this.props.getDate(this.state.sdate, this.state.edate);
  }
  
  onFocus() {
    this.setState({datePickOpen: true});
  }

  onBlur() {
    //prevent both close timeDropdownOpen and datePick Dropdown in one click
    setTimeout(() => {
      this.setState({datePickOpen: false, sdateInvalid: false, edateInvalid: false});
    }, 500);
  }

  onOpen = (type) =>{
    if(type === 's'){
      this.setState({
        sOpen:false
      })
    }else{
      this.setState({
        eOpen:false
      })
    }
  }

  handleTimeChange(event) {
    console.log(event);
    const format = event.format();
    const moment = format.substring(0,10) + ' ' + format.substring(11, 19);

    console.log({moment});
  }

	timeSelectToggle() {
    if (this.state.datePickOpen === false) {
      this.setState({
        timeDropdownOpen: !this.state.timeDropdownOpen,
      });
    }
  }
  
	dateChange(value, type) {
    const date = type==='s' ? 'sdate' : 'edate';
    const dateInvalid = type==='s' ? 'sdateInvalid' : 'edateInvalid';

    if (moment.isMoment(value)) {
      const format = value.format();
      const moment = dateFormat(format.substring(0,10), false) + ' ' + format.substring(11, 16);
      this.setState({ [date]: moment, [dateInvalid]: false })
      return ;
    } else {
      this.setState({ [dateInvalid]: true})
      return ;
    }
    this.onOpen()
	}
  oneDay() {
    this.sendDate(lastOne + currentHHMM, currentDateTime,'過去24小時')
    this.setState({ status: '過去24小時'});
  }
  sevenDays() {
    this.sendDate(lastSeven, currentDate,'過去7天')
    this.setState({ status: '過去7天'});
  }
	thirtyDays() {
    this.sendDate(lastThrity, currentDate,'過去30天')
		this.setState({ status: '過去30天'});
	}
	sixtyDays() {
    this.sendDate(lastSixty, currentDate,'過去60天')
		this.setState({ status: '過去60天'});
	}
	ninetyDays() {
    this.sendDate(lastNinety, currentDate,'過去90天')
		this.setState({ status: '過去90天'});
	}
	oneYear() {
    this.sendDate(lastYear, currentDate,'過去1年')
		this.setState({ status: '過去1年'});
  }

  sendDate(sdate,edate,status) {
    this.props.handleTimeStatus(status)
    this.props.setTime(sdate,edate)
  }

  confirm(e) {
		// e.preventDefault();
		this.sendDate(this.state.sdate,this.state.edate,'abs');
    this.setState({ status: '(' + this.state.sdate + ') to (' + this.state.edate + ')' });
    this.timeSelectToggle();
	}
  
	cancle(e) {
		e.preventDefault();
		this.timeSelectToggle();
	}

	render() {
    const {sdateInvalid, edateInvalid} = this.state;
		return (
      <ButtonDropdown className="mr-1" isOpen={this.state.timeDropdownOpen} toggle={this.timeSelectToggle}>
        <DropdownToggle caret className="date customer-dropdown-button">
          <div className='date-time'>{this.state.status}</div>
        </DropdownToggle>
        <DropdownMenu  className="drop-down-box">
          <DropdownItem className="dropdown-item" onClick={this.oneDay}>過去24小時</DropdownItem>
          <DropdownItem className="dropdown-item" onClick={this.sevenDays}>過去7天</DropdownItem>
          <DropdownItem className="dropdown-item" onClick={this.thirtyDays}>過去30天</DropdownItem>
          <DropdownItem className="dropdown-item" onClick={this.ninetyDays}>過去90天</DropdownItem>
          <DropdownItem className="dropdown-item" onClick={this.oneYear}>過去1年</DropdownItem>
          <CardBody className="box form-date-input">
          <Form action="" method="post" className="form-horizontal">
            <FormGroup row className='pick-time'>
              <Label>開始時間</Label>
              {sdateInvalid && <div className='pick-time-warning'>請輸入正確的日期格式 yyyy/mm/dd HH:MM</div>}
              <Datetime onChange={(val) => this.dateChange(val, 's')} defaultValue={this.state.sdate} value={this.state.sdate} viewDate={this.state.sdate} onFocus={this.onFocus} onBlur={this.onBlur}/>
            </FormGroup>
            <FormGroup row className='pick-time'>
              <Label>結束時間</Label>
              {edateInvalid && <div className='pick-time-warning'>請輸入正確的日期格式 yyyy/mm/dd HH:MM</div>}
              <Datetime onChange={(val) => this.dateChange(val, 'e')} defaultValue={this.state.edate} value={this.state.edate} viewDate={this.state.edate}	onFocus={this.onFocus} onBlur={this.onBlur}/>
            </FormGroup>
          </Form>
          <Button color="link" onClick={this.confirm}>確定</Button>
          <Button color="link" className="cancle-button" onClick={this.cancle}>取消</Button>
          </CardBody>
        </DropdownMenu>
      </ButtonDropdown>
		);
	}
}

const TimeSelect = connect(null, mapDispatchToProps)(TimeSelectComponent);

export default TimeSelect;



// WEBPACK FOOTER //
// ./src/components/timeSelect.js